import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin
} from "antd";
import { Component } from "react";
import "../styles/general.css";

import { GET, POST } from "../constants/request-type";
import {
  create_permission,
  get_all_role,
  permission,
  role
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Permission_new extends Component {
  state = { visible: false, name: "", list: [], role: "", load: true };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: role + "/" + get_all_role,
      data: null,
      token: token
    };
    try {
      const response = await MakeRequestAsync(request_details);
      this.setState({
        list: decryptSingleData(response.data.role),
        load: false
      });
    } catch (err) {
      this.setState({ load: false });
      logger.log(err);
      return openNotificationWithIcon("err", err);
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const { name, role } = this.state;

    const data = {
      name: name.toLowerCase(),
      role: role
    };

    const request_details = {
      type: POST,
      url: service_api,
      route: permission + "/" + create_permission,
      data: data,
      token: token
    };

    if (data.name.length === 0 || data.role.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { name, role, list, load } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          <PlusOutlined /> Crée permission
        </Button>
        <Drawer
          title="Creation de permission"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="name"
                  label="Nom"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez entrer le nom de permission"
                    }
                  ]}
                >
                  <Input
                    name="name"
                    placeholder="Veuillez entrer le nom de permission"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Select
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Selectionner parmis les options"
                  defaultValue={role}
                  onChange={(data) => {
                    return this.setState({ role: data });
                  }}
                >
                  {list.map((item) => (
                    <Option key={item._id}>
                      <span>{item.name}</span>
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Permission_new;
